import styled from 'styled-components';

import EditSVG from '../../../../assets/imgs/icon/pen-to-square.svg';
import { Content } from '../../../../GlobalComponents/Content';

interface AddFavoriteButtonProps {
	displayText: string;
	onAdd: () => void;
}

export const AddFavoriteButton = ({
	displayText,
	onAdd
}: AddFavoriteButtonProps): JSX.Element => {
	return (
		<Card onClick={onAdd}>
			<img
				src={EditSVG}
				style={{ width: '36px', height: '36px', marginRight: '16px' }}
			/>

			<Content $fontSize={24} $fontWeight={700}>
				{displayText}
			</Content>
		</Card>
	);
};

const Card = styled.div`
	border: 1px solid rgba(87, 87, 87, 0.25);
	border-radius: 8px;
	height: 168px;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	@media (max-width: 600px) {
		height: 120px;
	}
`;
